import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/ireader',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/ireader/app-ads.txt',
      name: 'ireaderTxt',
      component: () => import('@/view/official/ireaderTxt.vue')
    },
    {
      path: '/ireaderZh',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    { // 华语
      path: '/app-ads.txt',
      name: 'ireaderZhTxt',
      component: () => import('@/view/official/ireaderZhTxt.vue')
    },
    {
      path: '/storyroom',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/storyroom/app-ads.txt',
      name: 'storyroomTxt',
      component: () => import('@/view/official/storyroomTxt.vue')
    },
    {
      path: '/storysome',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/storyaholic',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/mynovel',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/storysome/app-ads.txt',
      name: 'storysomeTxt',
      component: () => import('@/view/official/storysomeTxt.vue')
    },
    {
      path: '/storyaholic/app-ads.txt',
      name: 'storyaholicTxt',
      component: () => import('@/view/official/storyaholicTxt.vue')
    },
    {
      path: '/mynovel/app-ads.txt',
      name: 'mynovelTxt',
      component: () => import('@/view/official/mynovelTxt.vue')
    },
    {
      path: '/novelworld',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/readnovel',
      name: 'home',
      component: () => import('@/view/official/home.vue')
    },
    {
      path: '/novelworld/app-ads.txt',
      name: 'novelworldTxt',
      component: () => import('@/view/official/novelworldTxt.vue')
    },
    {
      path: '/readnovel/app-ads.txt',
      name: 'readnovelTxt',
      component: () => import('@/view/official/readnovelTxt.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js